<template>
  <v-data-table
    id="loginHistoryMainTable"
    class="loginHistoryMainTable"
    :items="historyItems"
    :loading="loading.mainTable"
    :headers="cols"
    hide-default-footer
    :page.sync="footerPagination.page"
    :items-per-page="footerPagination.itemsPerPage"
    @update:sort-desc="handleSort"
  >
    <!-- ДАТА -->
    <template #[`item.created_at`]="{item}">
        <span class="login-history-item">
          {{
            moment
                .utc(item.created_at)
                .format('DD.MM.YY')
          }} - {{
            moment
                .utc(item.created_at)
                .format('HH:mm')
          }}
        </span>
    </template>

    <!-- IP -->
    <template #[`item.ip`]="{item}">
        <span class="login-history-item">
          {{ item.ip }}
        </span>
    </template>

    <!-- Источник -->
    <template #[`item.source`]="{item}">
        <span class="login-history-item">
          {{ item.source }}
        </span>
    </template>

    <!-- Состояние -->
    <template #[`item.login_success`]="{item}">
        <span v-if="!!item['login_success']" class="login-history-item">
          {{ $t('loginHistory.success') }}
        </span>
        <span v-else-if="item.type_error" class="login-history-state-error">
           {{ $t('loginHistory.'+ item.type_error) }}
        </span>
        <span v-else class="login-history-state-error">
          {{ $t('loginHistory.error') }}
        </span>
    </template>

    <template #footer>
      <v-data-footer
          :options="{
              page: footerOptions.page,
              itemsPerPage: footerPagination.itemsPerPage
            }"
          :pagination="footerPagination"
          @update:options="updateFooterOptions"
      >
        <template
          #page-text
        >
          <div class="d-flex justify-between align-center">
            <v-autocomplete
                :value="footerPagination.page"
                :items="pages"
                dense
                hide-details
                class="pagination-page-select"
                @change="goToPage"
            >
              <template #prepend>
                <div>
                  {{ `${$t('common.page')}: ` }}
                </div>
              </template>
            </v-autocomplete>
          </div>
        </template>
      </v-data-footer>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: 'LoginHistoryMainTable',

  data() {
    return {
      moment
    }
  },

  computed: {
    ...mapGetters({
      historyItems: 'loginHistory/historyItems',
      profile: 'main/profile',
      loading: 'loginHistory/loading',
      pagination: 'loginHistory/pagination'
    }),

    cols () {
      return [
        {
          text: `${this.$t('loginHistory.dateAndTime')} UTC (+0:00)`,
          value: 'created_at',
          width: 120
        },
        {
          text: 'IP',
          value: 'ip',
          width: 110
        },
        {
          text: this.$t('loginHistory.source'),
          value: 'source',
          width: 80
        },
        {
          text: this.$t('loginHistory.state'),
          value: 'login_success',
          width: 60
        }
      ]
    },

    footerOptions() {
      const options = {}

      options.page = this.pagination.currentPage
      options.itemsPerPage = this.pagination.perPage

      return options
    },

    footerPagination() {
      const pagination = {}

      pagination.page = this.pagination.currentPage
      pagination.itemsPerPage = this.pagination.perPage
      pagination.pageStart = this.pagination.from - 1
      pagination.pageStop = this.pagination.to
      pagination.pageCount = this.pagination.lastPage
      pagination.itemsLength = this.pagination.total

      return pagination
    },

    pages () {
      const pages = []

      if (this.footerPagination && this.footerPagination.pageCount) {
        for (let i = 1; i <= this.footerPagination.pageCount; i++) {
          pages.push(i)
        }
      }

      return pages
    }
  },

  created() {
    this.$store.dispatch('loginHistory/loadHistory', {
      page: 1,
      itemsPerPage: 25,
      sort: 'desc'
    })
  },

  methods: {
    handleSort(isDesc) {
      const payload = {
        page: 1,
        itemsPerPage: 25,
        sort: 'desc'
      }

      if (isDesc[0] !== undefined) {
        payload.sort = isDesc[0] ? 'desc' : 'asc'
      }

      this.$store.dispatch('loginHistory/loadHistory', payload)
    },

    updateFooterOptions(options) {
      const payload = {
        sort: this.pagination.sort,
        page: options.page,
        itemsPerPage: options.itemsPerPage
      }

      this.$store.dispatch('loginHistory/loadHistory', payload)
    },

    goToPage (page) {
      const payload = {
        page: page,
        itemsPerPage: this.pagination.perPage,
        sort: this.pagination.sort,
      }

      this.$store.dispatch('loginHistory/loadHistory', payload)
    }
  }
}
</script>

<style>
.loginHistoryMainTable .v-data-table__wrapper {
  max-height: 512px;
  overflow-y: auto;
}
.login-history-item {
  font-weight: 500;
  font-size: 13px;
  line-height: 108%;
  color: #000000;
}

.login-history-state-error {
  font-weight: 500;
  font-size: 13px;
  line-height: 108%;
  color: #D50909;
}

#loginHistoryMainTable .v-data-footer__select {
  visibility: hidden;
}

.pagination-page-select {
  margin-top: 0;
}

.pagination-page-select .v-input__control {
  max-width: 50px;
}

.pagination-page-select.v-select.v-input--is-focused input {
  min-width: unset;
}
</style>
